import React from "react";

export class Pager extends React.Component {
	constructor(props) {
		super(props);
	}

	setPage(pageOffset) {
		const perPage = 10;
		let page = this.props.page;
		page += pageOffset;
		if(page < 0) {
			page = 0;
		}
		if(page * perPage > this.props.count) {
			page = Math.floor(this.props.count / perPage);
		}
		if(this.props.href) {
			window.location = this.props.href;
		}
		this.props.onChange(page);
	}

	hasPrev() {
		return this.props.page > 0;
	}

	hasNext() {
		return this.props.page * this.props.perPage < this.props.count;
	}

	render() {
		return (this.props.count > this.props.perPage) ? (
			<div className="center">
				<button className="btn btn-secondary" onClick={() => this.setPage(-1)} disabled={this.props.disabled || !this.hasPrev()}>Vorherige Seite</button>
				<span>&nbsp;</span>
				<button className="btn btn-secondary" onClick={() => this.setPage(1)} disabled={this.props.disabled || !this.hasNext()}>Nächste Seite</button>
			</div>
		) : null;
	}
}